import { DateTime } from 'luxon';

const transformDateRangeToAlgoliaFilter = (value?: string) => {
    if (!value || value.length === 0) return undefined;
    const [from, to = DateTime.now().toMillis()] = value.split(',').map((date: string) => DateTime.fromISO(date).toMillis());
    return `createdAt >= ${from} AND createdAt <= ${to}`;
};

export default transformDateRangeToAlgoliaFilter;
